import { createSlice } from '@reduxjs/toolkit'

import { AiAutomationStatsState, LoaderStatus } from 'apps/aiAutomation/store/stats/lib/types'
import { AiAutomationApi } from 'shared/api/requests/aiAutomation'
import { makeCreateAsyncAction } from 'shared/lib/redux'

const createAsyncAction = makeCreateAsyncAction({
  scope: 'ai',
  section: 'ai_always_on_automation',
})

const NAMESPACE = 'aiAutomationStats'

export const AiAutomationStatsInitialState: AiAutomationStatsState = {
  stats: {
    faq: {
      started: {
        total: 0,
        unique: 0,
      },
      succeeded: {
        total: 0,
        unique: 0,
      },
    },
    social_engagement: {
      started: {
        total: 0,
        unique: 0,
      },
      succeeded: {
        total: 0,
        unique: 0,
      },
    },
  },
  loaderStatus: LoaderStatus.NOT_LOADED,
}

const { reducer } = createSlice({
  initialState: AiAutomationStatsInitialState,
  name: NAMESPACE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatsFx.pending, (state) => {
      state.loaderStatus = LoaderStatus.LOADING
    })

    builder.addCase(getStatsFx.fulfilled, (state, action) => {
      state.stats = action.payload
      state.loaderStatus = LoaderStatus.LOADED
    })
  },
})

const getStatsFx = createAsyncAction(`${NAMESPACE}/getStatsFx`, async () => {
  const { data } = await AiAutomationApi.getStats()
  return data.stats
})

export const AiAutomationStatsActions = {
  getStatsFx,
}

export const AiAutomationStatsReducer = reducer

const getState = (state: RootState) => state.aiAutomation.stats

export const AiAutomationStatsSelectors = {
  getState,

  getInstantAnswersTotalSucceeded: (state: RootState) => getState(state).stats.faq.succeeded.total,
  getSocialEngagementTotalSucceeded: (state: RootState) =>
    getState(state).stats.social_engagement.succeeded.total,

  getLoaderStatus: (state: RootState) => getState(state).loaderStatus,
}
